// useSectionTrackingFlush.js
// Mount this once, high up (e.g. in App.js's Layout), passing in whether the client
// is currently logged in. Runs one shared flush timer for every SectionTracker on the page.

import { useEffect } from "react";
import { flushSectionEvents, closeAllOpenSections } from "./sectionEventQueue";

const FLUSH_INTERVAL_MS = 18000;

export default function useSectionTrackingFlush(enabled) {
  useEffect(() => {
    if (!enabled) return;

    const intervalId = setInterval(() => {
      flushSectionEvents();
    }, FLUSH_INTERVAL_MS);

    function handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
        // Close out any section still in view so we don't lose that dwell time,
        // then flush immediately rather than waiting for the next interval tick.
        closeAllOpenSections();
        flushSectionEvents();
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);

    function handleBeforeUnload() {
      closeAllOpenSections();
      flushSectionEvents(); // best-effort - may not always complete before the tab closes
    }
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [enabled]);
}